"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _redux = require("redux");

var _Auth = _interopRequireDefault(require("FileManagerCore/reducers/Auth"));

var _Folders = _interopRequireDefault(require("FileManagerCore/reducers/Folders"));

var _Files = _interopRequireDefault(require("FileManagerCore/reducers/Files"));

var _Canva = _interopRequireDefault(require("FileManagerCore/reducers/Canva"));

var _Dropbox = _interopRequireDefault(require("FileManagerCore/reducers/Dropbox"));

var _UserSettings = _interopRequireDefault(require("FileManagerCore/reducers/UserSettings"));

var _UploadingFiles = _interopRequireDefault(require("FileManagerCore/reducers/UploadingFiles"));

var _Limits = _interopRequireDefault(require("FileManagerCore/reducers/Limits"));

var _ActionTypes = require("../actions/ActionTypes");

var _Panel = _interopRequireDefault(require("./Panel"));

var _DetailHeights = _interopRequireDefault(require("./DetailHeights"));

var _withHistory = _interopRequireDefault(require("./withHistory"));

var _Shutterstock = _interopRequireDefault(require("FileManagerCore/reducers/Shutterstock"));

var _Configuration = _interopRequireDefault(require("./Configuration"));

var _EditFile = _interopRequireDefault(require("./EditFile"));

var _EditAndCreateImage = _interopRequireDefault(require("FileManagerCore/reducers/EditAndCreateImage"));

var _PortalMeta = _interopRequireDefault(require("FileManagerCore/reducers/PortalMeta"));

var _IdentityRepository = _interopRequireDefault(require("FileManagerCore/reducers/IdentityRepository"));

var _VideoThumbnails = _interopRequireDefault(require("FileManagerCore/reducers/VideoThumbnails"));

var _Filter = _interopRequireDefault(require("./Filter"));

var _ImageOptimizationSettings = _interopRequireDefault(require("./ImageOptimizationSettings"));

var _Suspension = _interopRequireDefault(require("FileManagerCore/reducers/Suspension"));

var _FileDetails = _interopRequireDefault(require("FileManagerCore/reducers/FileDetails"));

var _default = (0, _redux.combineReducers)({
  auth: _Auth.default,
  configuration: _Configuration.default,
  canva: _Canva.default,
  dropbox: _Dropbox.default,
  editFile: _EditFile.default,
  editAndCreateImage: _EditAndCreateImage.default,
  folders: _Folders.default,
  files: _Files.default,
  fileDetails: _FileDetails.default,
  uploadingFiles: _UploadingFiles.default,
  detailHeights: _DetailHeights.default,
  panel: (0, _withHistory.default)(_Panel.default, [_ActionTypes.SEARCH, _ActionTypes.SELECT_FILE, _ActionTypes.SELECT_STOCK_FILE]),
  shutterstock: (0, _Shutterstock.default)({
    concatenateResults: true
  }),
  imageOptimizationSettings: _ImageOptimizationSettings.default,
  userSettings: _UserSettings.default,
  identityRepository: _IdentityRepository.default,
  portalMeta: _PortalMeta.default,
  limits: _Limits.default,
  videoThumbnail: _VideoThumbnails.default,
  filter: _Filter.default,
  suspension: _Suspension.default
});

exports.default = _default;
module.exports = exports.default;